export const monthNames = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
export type MonthListEntry = { name: string; ymd: string };

export function getMonthList() {
  const months: MonthListEntry[] = [];
  const date = new Date();
  date.setUTCDate(1);
  date.setUTCHours(0, 0, 0, 0);
  const start = new Date("2016-08-01");

  for (let i = 0; i < 12 && date > start; i++) {
    const ymd = date.toISOString().replace(/T.*/, "");
    months.push({
      name: monthNames[date.getUTCMonth()] + " " + date.getUTCFullYear(),
      ymd,
    });
    date.setUTCMonth(date.getUTCMonth() - 1);
  }

  return months;
}
